import React from 'react'

import styles from './index.module.scss'

function Tab({ tab, action = () => {}, currentTab }) {
	return (
		<button
			className={styles.tab}
			onClick={() => action(tab.id)}
			data-current={currentTab === tab.id}>
			{tab.icon}
			{tab.title}
		</button>
	)
}

export default Tab
